import { useState, useEffect } from "react";
import MenuServices from "services/MenuServices";

const useSidebar = () => {
  const [sidebar, setSidebar] = useState([]); // Store menu data
  const [, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await MenuServices.getAllAdminMenu();
        if (response.status) {
          setSidebar(response.data);
        } else {
          console.error("Response status is false:", response);
        }
      } catch (error) {
        console.error("Failed to fetch menu data:", error);
      } finally {
        setLoading(false); // Ensure loading state is updated
      }
    };

    fetchMenu();
  }, []);

  return { sidebar }; // Return only data, not JSX
};

export default useSidebar;
